export default __webpack_public_path__ + "static/media/insulation_4.b817148f.JPG";